import React from 'react';
import { Helmet } from 'react-helmet-async';
import SeoHead from './SeoHead';
import { BRAND } from '../../config/brand';

const SITE_URL = (process.env.REACT_APP_SITE_URL || BRAND.url).replace(/\/+$/, '');

const HinduCalendarSeo: React.FC<{ date?: string; validDate?: boolean }> = ({ date, validDate = true }) => {
  // Search metadata stays stable across the user's display-date preferences.
  const dateLabel = date && validDate ? new Intl.DateTimeFormat('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(`${date}T12:00:00Z`)) : '';
  const path = date && validDate ? `/hindu-calendar/${date}` : '/hindu-calendar';
  const title = date && !validDate ? `Invalid Calendar Date | ${BRAND.name}` : dateLabel
    ? `${dateLabel} Panchang & Hindu Calendar | ${BRAND.name}`
    : `Hindu Calendar, Festivals, Vrat & Daily Panchang | ${BRAND.name}`;
  const description = dateLabel
    ? `Explore the Hindu calendar for ${dateLabel}: festivals, vrat, tithi, nakshatra, yoga, karana and daily Panchang timings for your selected location.`
    : 'Explore the Hindu calendar with festivals, vrat, Purnima, Amavasya and daily Panchang. Select a date and city for local festival and Panchang timings.';
  const url = `${SITE_URL}${path}`;
  const crumbs = [
    { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
    { '@type': 'ListItem', position: 2, name: 'Hindu Calendar', item: `${SITE_URL}/hindu-calendar` },
    ...(dateLabel ? [{ '@type': 'ListItem', position: 3, name: dateLabel, item: url }] : []),
  ];
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': dateLabel ? 'WebPage' : 'CollectionPage', '@id': `${url}#webpage`, url, name: title, description, breadcrumb: { '@id': `${url}#breadcrumb` }, ...(dateLabel ? { isPartOf: { '@type': 'CollectionPage', url: `${SITE_URL}/hindu-calendar`, name: 'Hindu Calendar' } } : {}) },
      { '@type': 'BreadcrumbList', '@id': `${url}#breadcrumb`, itemListElement: crumbs },
    ],
  };
  return <>
    <SeoHead title={title} description={description} path={path} robots={validDate ? 'index,follow,max-image-preview:large' : 'noindex,follow'} />
    {validDate && <Helmet><script type="application/ld+json">{JSON.stringify(schema).replace(/</g, '\\u003c')}</script></Helmet>}
  </>;
};

export default HinduCalendarSeo;
